
import {useContext, useEffect, useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {appContext} from "../state";
import Clone from "../utils/clone";
import {GoogleLogin} from "@react-oauth/google";
import {message, Typography, Form, Input, Flex, Button, Checkbox, Alert, App} from "antd";
import Favicon from "../icons/Favicon";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import loadScript from "../utils/script";
import SignUpPattern from "./SignUpPattern";
import AppLocalStorage from "../storage/localStorage";

function SignInUp(props) {

    const navigate = useNavigate();
    const {appStateContextValue} = useContext(appContext);
    const [appState, setAppState] = appStateContextValue
    const appStateRef = useRef(appState);
    const [passwordInputType, setPasswordInputType] = useState('password');
    const [authStatusMsg, setAuthStatusMsg] = useState(null);

    const { message, modal, notification } = App.useApp();
    useEffect(() => {
        window.app.onSignInSuccess = onSignInSuccess
        window.onCaptchaReady = () => {
            console.log('ON_CAPTCHA_READY')
        }
        loadScript('https://www.google.com/recaptcha/api.js?render='+process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY)
    }, []);

    useEffect(() => {
        appStateRef.current = appState
    },[appState]);

    async function onSignInSuccess (credentialResponse) {
        console.log(credentialResponse);

        const url = process.env.REACT_APP_SERVER_API_HOST+"/auth/signin-social"
        try {
            let headers = new Headers()
            headers.append('Content-Type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
                body:JSON.stringify({googleToken:credentialResponse.credential})
            };

            const response = await fetch(url,requestOptions);
            if (!response.ok) {
                console.error(new Error(`Response status: ${response.status}`))
            }
            if (response.status === 200) {
                const json = await response.json();
                console.log('RESPONSE:',json)
                let newAppState = Clone(appStateRef.current)
                newAppState.user.email = json.email
                newAppState.user.image = json.image
                localStorage.setItem('token',json.token)
                setAppState(newAppState)
                navigate("/");
            } else {
                message.open({type: 'error', content: 'Login failed!'});
            }

        } catch (error) {
            console.error(error.message);
        }


        if (props.isSignUp) {
            props.onSignUpSuccess(credentialResponse)
        } else {
            props.onSignInSuccess(credentialResponse)
        }
    }

    function onLoginFailed () {
        console.log('Login Failed');
    }

    useEffect(() => {

    }, []);

    function togglePasswordInput () {
        setPasswordInputType(passwordInputType === 'password' ? 'text' : 'password')
    }

    const onFormSubmit = (values) => {
        //console.log('VALS:', values);
        window.grecaptcha.ready(function() {
            console.log('SITE_KEY',process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY,)
            window.grecaptcha.execute(process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
                //console.log('TOKEN',token)
                startSignIn(values.email,values.password, token).then( () => {})
            });
        });
    };

    async function startSignIn (email,password, captchaToken) {
        let url = process.env.REACT_APP_SERVER_API_HOST+"/auth/signin"
        if (props.type === 'SIGN_UP') {
            url = process.env.REACT_APP_SERVER_API_HOST+"/auth/signup"
        }
        try {
            let headers = new Headers()
            headers.append('Content-Type', 'application/json')
            headers.append("token", localStorage.getItem('token'));
            let requestOptions = {
                method: 'POST',
                headers: headers,
                body:JSON.stringify({email:email,password:password,captchaToken:captchaToken,uuid:appState.user.uuid})
            };

            const response = await fetch(url,requestOptions);
            if (response.status === 200) {
                const json = await response.json();
                console.log('RESPONSE:',json)

                if (json.error === null) {
                    let newAppState = Clone(appStateRef.current)
                    newAppState.user.email = json.user.email
                    newAppState.user.uuid = json.user.uuid
                    localStorage.setItem('token',json.user.token)
                    setAppState(newAppState)
                    AppLocalStorage.save(newAppState)
                    if (props.type === 'SIGN_IN') {
                        message.open({type: 'success', content: 'Login successful!'});
                    }
                    if (props.type === 'SIGN_UP') {
                        message.open({type: 'success',  duration: 10, content: 'Thanks for signing up for Mocky! Please check your mail.'});
                    }
                    navigate("/");
                } else {
                    if (json.code === 'INVALID_PASSWORD') {
                        setAuthStatusMsg({key:new Date(), type:'error',message:'Invalid password!',description:'Please choose a password with minimum 8 characters, at least one number and at least one special character.'})
                    }
                    if (json.code === 'EMAIL_EXISTS') {
                        setAuthStatusMsg({key:new Date(), type:'error',message:'Email exists!',description:'This email has already an account.'})
                    }
                    message.open({type: 'error', content: json.error});
                }
            } else {
                message.open({type: 'error', content: 'Login failed!'});
            }

        } catch (error) {
            console.error(error.message);
        }
    }

    return (
        <>
            <div className="col form">
                <div className="cont">
                    <Favicon></Favicon>
                    <Typography.Title className="header" level={3}>
                        {props.type === 'SIGN_UP' ? 'Sign up to Mocky' : 'Sign in to Mocky'}
                    </Typography.Title>

                    <Form
                        name="login"
                        initialValues={{
                            remember: true,
                        }}
                        style={{
                            minWidth: 360,
                            maxWidth: 360,
                        }}
                        onFinish={onFormSubmit}
                    >
                        {authStatusMsg ?  <div>
                            <Alert
                                key={authStatusMsg.key}
                                message={authStatusMsg.message}
                                description={authStatusMsg.description}
                                type={authStatusMsg.type || 'error'}
                                closable
                            />
                            <br/>
                        </div> : false}
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Email!',
                                },
                            ]}
                        >
                            <Input prefix={<UserOutlined/>} placeholder="Email"/>
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Password!',
                                },
                            ]}
                        ><Input prefix={<LockOutlined onClick={togglePasswordInput}/>} type={passwordInputType} placeholder="Password"/>
                        </Form.Item>
                        {<Form.Item>
                            <Flex justify="space-between" align="center"><Link to="/forgot-password">Forgot password?</Link></Flex>
                        </Form.Item>}
                        <div id="google-captcha"></div>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit">
                                {props.type === 'SIGN_IN' ? 'Sign in' : ' Sign up'}
                            </Button>
                            <div className="or">or</div>
                        </Form.Item>
                    </Form>


                     <div className="login-btn">
                        <GoogleLogin
                            text={props.text || 'signup_with'}
                            onSuccess={onSignInSuccess}
                            onError={onLoginFailed}
                        />
                    </div>


                    {props.type === 'SIGN_UP' ? <div className="already-signed-up">
                        Already signed up? <Link to="/signin">Sign In</Link>
                    </div> : <div className="already-signed-up">
                        No account yet? <Link to="/signup">Sign Up</Link>
                    </div>}

                </div>
                <div className="privacy-text">
                    By signing up you agree to Mocky's <a href={process.env.REACT_APP_LANDING_PAGE+"/privacy"}>Privacy Policy</a> and <a href={process.env.REACT_APP_LANDING_PAGE+"/terms"}>Terms
                    of Service</a> .
                </div>
            </div>
            <div className="col pattern">
                <SignUpPattern></SignUpPattern>
            </div>
        </>
    );
}

export default SignInUp;
